import { Col, Form, Input, Row, Select, Typography } from "antd";
import { memo, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useSportConfiguration } from "~hooks/useSportConfiguration.js";
import { Genders } from "~utilities/constants.js";
import TeamColors from "./TeamColors";
import { noLeadingOrTrailingSpacesRule } from "~utils/noLeadingOrTrailingSpacesRule.ts";

const GENDER_LIST = Object.values(Genders);
const STATUS = ["ACTIVE", "INACTIVE", "PENDING"];

//TODO refactor it
const AddAndEditTeamForm = (props) => {
  const { entityGroupList, handleSetFormRef, team, venueList } = props;
  const { formatMessage } = useIntl();
  const [form] = Form.useForm();
  const initValues = {
    ...team,
    primary: "000000",
    secondary: "000000",
    tertiary: "000000",
  };
  const [defaultVenueId, setDefaultVenueId] = useState(team?.defaultVenueId);
  const [entityGroupId, setEntityGroupId] = useState(team?.entityGroupId);
  const { entityStandards: STANDARDS, ageGroups: AGE_GROUPS } = useSportConfiguration();

  useEffect(() => {
    handleSetFormRef(form);
  }, []);

  const handleDefaultVenue = (value) => {
    setDefaultVenueId(value || null);
    form.setFieldValue("defaultVenueId", value || null);
  };

  const handleEntityGroupId = (value) => {
    setEntityGroupId(value || null);
    form.setFieldValue("entityGroupId", value || null);
  };

  return (
    <Form
      form={form}
      labelCol={{
        span: 10,
      }}
      colon={false}
      labelWrap={true}
      initialValues={initValues}
    >
      <Row>
        <Col span={13}>
          <Form.Item
            labelCol={{
              span: 11,
            }}
            required={true}
            name={"nameFullLocal"}
            label={formatMessage({
              id: "name.local.full",
              defaultMessage: "Local Full Name",
            })}
            tooltip={formatMessage(
              {
                id: "form.help.local.full.name.item",
                defaultMessage: "The name of the {item} in the local Language",
              },
              {
                item: formatMessage({
                  id: "team",
                  defaultMessage: "Team",
                }),
              },
            )}
            rules={[
              {
                required: true,
                message: "Local Full Name is Required",
              },
              {
                min: 2,
                message: formatMessage({ id: "form.validation.min.length" }, { length: 2 }),
              },
              noLeadingOrTrailingSpacesRule(formatMessage),
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={11}>
          <Form.Item
            labelCol={{
              span: 11,
            }}
            name={"codeLocal"}
            label={formatMessage({
              id: "name.local.code",
              defaultMessage: "Local Code",
            })}
            tooltip={formatMessage(
              {
                id: "form.help.local.code.item",
                defaultMessage: "The code of the {item} in the local Language",
              },
              {
                item: formatMessage({
                  id: "team",
                  defaultMessage: "Team",
                }),
              },
            )}
            rules={[
              {
                max: 5,
                message: formatMessage({ id: "form.validation.max.length" }, { length: 5 }),
              }
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            labelCol={{
              span: 10,
            }}
            name={"nameFullLatin"}
            label={formatMessage({
              id: "name.latin.full",
              defaultMessage: "Latin Full Name",
            })}
            tooltip={formatMessage(
              {
                id: "form.help.latin.full.name.item",
                defaultMessage: "The full name of the {item} in latin characters",
              },
              {
                item: formatMessage({
                  id: "team",
                  defaultMessage: "Team",
                }),
              },
            )}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            labelCol={{
              span: 10,
            }}
            name={"codeLatin"}
            label={formatMessage({
              id: "name.latin.code",
              defaultMessage: "Latin Code",
            })}
            tooltip={formatMessage(
              {
                id: "form.help.latin.code.item",
                defaultMessage: "The code of the {item} in latin characters",
              },
              {
                item: formatMessage({
                  id: "team",
                  defaultMessage: "Team",
                }),
              },
            )}
            rules={[
              {
                maxLength: 5,
                message: "Max 5 characters",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name={"gender"}
            label={formatMessage({
              id: "gender",
              defaultMessage: "Gender",
            })}
            tooltip={formatMessage({
              id: "form.help.person.gender",
              defaultMessage: "The gender of the person",
            })}
          >
            <Select>
              {GENDER_LIST?.map((gender) => (
                <Select.Option key={gender} value={gender}>
                  {gender}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={16}>
          <Form.Item
            labelCol={{
              span: 7,
            }}
            name={"standard"}
            label={formatMessage({
              id: "standard",
              defaultMessage: "Standard",
            })}
            tooltip={formatMessage({
              id: "form.help.season.standard",
              defaultMessage: "The playing standard of the season",
            })}
          >
            <Select>
              {STANDARDS?.map((standard) => (
                <Select.Option value={standard} key={standard}>
                  {standard}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={9}>
          <Form.Item
            name={"status"}
            label={formatMessage({
              id: "status",
              defaultMessage: "Status",
            })}
            tooltip={formatMessage(
              {
                id: "form.help.status.item",
                defaultMessage: "What is the current status of this {item}?",
              },
              {
                item: formatMessage({
                  id: "team",
                  defaultMessage: "Team",
                }),
              },
            )}
            required
            rules={[{ required: true }]}
          >
            <Select>
              {STATUS?.map((status) => (
                <Select.Option value={status} key={status}>
                  {status}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={15}>
          <Form.Item
            labelCol={{
              span: 6,
            }}
            name={"entityGroupId"}
            label={formatMessage({
              id: "club",
              defaultMessage: "Club",
            })}
            tooltip={formatMessage({
              id: "form.help.team.club",
              defaultMessage: "What club does this team belong to?",
            })}
          >
            <Form.Item name={"entityGroupId"} style={{ width: "100%" }}>
              <Select onChange={handleEntityGroupId} defaultValue={entityGroupId} allowClear={true}>
                {(entityGroupList || []).map((entityGroup) => (
                  <Select.Option key={entityGroup?.entityGroupId} value={entityGroup?.entityGroupId}>
                    {entityGroup?.nameFullLocal}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Form.Item>
        </Col>
        <Col span={13}>
          <Form.Item
            labelCol={{
              span: 13,
            }}
            name={"internationalReference"}
            label={formatMessage({
              id: "international.reference",
              defaultMessage: "International Reference",
            })}
            tooltip={formatMessage(
              {
                id: "form.help.international.reference.item",
                defaultMessage: "The international reference for this {item} given by the sport governing body",
              },
              {
                item: formatMessage({
                  id: "team",
                  defaultMessage: "Team",
                }),
              },
            )}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={11}>
          <Form.Item
            name={"ageGroup"}
            label={formatMessage({
              id: "ageGroup",
              defaultMessage: "Age Group",
            })}
            tooltip={formatMessage({
              id: "form.help.season.age.group",
              defaultMessage: "The age group of the season",
            })}
          >
            <Select showSearch>
              {AGE_GROUPS?.map((ageGroup) => (
                <Select.Option value={ageGroup} key={ageGroup}>
                  {ageGroup}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            labelCol={{
              span: 5,
            }}
            name={"defaultVenueId"}
            label={formatMessage({
              id: "venue.default",
              defaultMessage: "Default Venue",
            })}
            tooltip={formatMessage({
              id: "form.help.team.venue",
              defaultMessage: "The default venue for this Team",
            })}
          >
            <Form.Item name={"defaultVenueId"} style={{ width: "100%" }}>
              <Select onChange={handleDefaultVenue} defaultValue={defaultVenueId} allowClear={true}>
                {venueList?.map((venue) => (
                  <Select.Option key={venue?.venueId} value={venue?.venueId}>
                    {venue?.nameLocal}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Typography.Title level={5}>Colors</Typography.Title>
        </Col>
      </Row>
      <TeamColors {...props} form={team} />
      <Row>
        <Col span={24}>
          <Typography.Title level={5}>Social</Typography.Title>
        </Col>
        <Col span={24}>
          <Form.Item
            labelCol={{
              span: 4,
            }}
            name={["social", "website"]}
            label={formatMessage({
              id: "website",
              defaultMessage: "Website",
            })}
            tooltip={formatMessage(
              {
                id: "form.help.item.website",
                defaultMessage: "{item} Website",
              },
              {
                item: formatMessage({
                  id: "person",
                  defaultMessage: "Person",
                }),
              },
            )}
            rules={[
              {
                pattern: "^https?://(www)?([A-Z0-9a-z._-])+$",
                message: "Please enter a valid url",
              },
            ]}
          >
            <Input placeholder="http(s)://yourwebsite.domain" />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            labelCol={{
              span: 4,
            }}
            name={["social", "facebook"]}
            label={formatMessage({
              id: "facebook",
              defaultMessage: "Facebook",
            })}
            tooltip={formatMessage(
              {
                id: "form.help.item.facebook",
                defaultMessage: "{item} Facebook",
              },
              {
                item: formatMessage({
                  id: "person",
                  defaultMessage: "Person",
                }),
              },
            )}
            rules={[
              {
                pattern: "^(https://)?(www.)?facebook.com/[A-Za-z0-9.]+$",
                message: "Please enter a valid url",
              },
            ]}
          >
            <Input placeholder="https://www.facebook.com/username" />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            labelCol={{
              span: 4,
            }}
            name={["social", "twitter"]}
            label={formatMessage({
              id: "twitter",
              defaultMessage: "Twitter",
            })}
            tooltip={formatMessage(
              {
                id: "form.help.item.twitter",
                defaultMessage: "{item} Twitter",
              },
              {
                item: formatMessage({
                  id: "person",
                  defaultMessage: "Person",
                }),
              },
            )}
            rules={[
              {
                pattern: "^(https://)?(www.)?twitter.com/[A-Za-z0-9_]+$",
                message: "Please enter a valid url",
              },
            ]}
          >
            <Input placeholder="https://twitter.com/username" />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            labelCol={{
              span: 4,
            }}
            name={["social", "instagram"]}
            label={formatMessage({
              id: "instagram",
              defaultMessage: "Instagram",
            })}
            tooltip={formatMessage(
              {
                id: "form.help.item.instagram",
                defaultMessage: "{item} Instagram",
              },
              {
                item: formatMessage({
                  id: "person",
                  defaultMessage: "Person",
                }),
              },
            )}
            rules={[
              {
                pattern: "^(https://)?(www.)?instagram.com/[A-Za-z0-9_.]+$",
                message: "Please enter a valid url",
              },
            ]}
          >
            <Input placeholder="https://www.instagram.com/username" />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default memo(AddAndEditTeamForm);
